import { LocaleId } from '@domgen/dgx-fe-i18n';
import { TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n/lib/models/translation-dictionary/translation-dictionary-mapping.type';
import { FeatureApplianceDetailsSteppedTranslationDictionary } from '../models/i18n/feature-appliance-details-stepped-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureApplianceDetailsSteppedTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      APPLIANCE_DETAILS_CONTINUE_BUTTON: 'Skip and continue to checkout',
      APPLIANCE_DETAILS_STEPPED_FORM_APPLIANCE_CATEGORY_CODE_ERROR_REQUIRED:
        'Please select an appliance category',
      APPLIANCE_DETAILS_STEPPED_FORM_APPLIANCE_CODE_ERROR_REQUIRED:
        'Please select an appliance',
      APPLIANCE_DETAILS_STEPPED_FORM_APPLIANCE_CODE_BUILT_IN_ERROR_REQUIRED:
        'Please select a value',
      APPLIANCE_DETAILS_STEPPED_FORM_BRAND_CODE_ERROR_REQUIRED:
        'Please select a brand',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_NUMBER_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_NUMBER_ERROR_REQUIRED:
        'Please enter your model number',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_SERIAL_NUMBER_ARE_INCORRECT:
        'No, this is incorrect',
      APPLIANCE_DETAILS_STEPPED_FORM_PHOTO_REG_PANEL_TITLE:
        "We've captured your appliance information",
      APPLIANCE_DETAILS_STEPPED_FORM_PHOTO_REG_PANEL_SUBTITLE:
        'Continue with your registration below',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_DATE_ERROR_AFTER_DATE:
        'Please select a date that is in the last 8 years',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_DATE_ERROR_BEFORE_DATE:
        'Please select a date that is in the past',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_DATE_ERROR_REQUIRED:
        'Please select a purchase date',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_ERROR_REQUIRED:
        'Please enter a purchase price',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_ERROR_MIN_LENGTH:
        'Please enter a value greater than 1',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_ERROR_MAX_LENGTH:
        "You've exceeded the maximum price",
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_SUMMARY_PANEL_TITLE:
        'Check your appliance information is correct.',
      APPLIANCE_DETAILS_STEPPED_FORM_REQUIRED_FIELD: '* Required field',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIAL_NUMBER_ERROR_MAX_LENGTH:
        'Enter a minimum of 9 and a maximum of 20 characters.',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIAL_NUMBER_ERROR_MIN_LENGTH:
        'Enter a minimum of 9 and a maximum of 20 characters.',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIAL_NUMBER_ERROR_REQUIRED:
        'Please enter your serial number',
      APPLIANCE_DETAILS_STEPPED_FORM_SUBMIT_BUTTON: 'Continue',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_SUBMIT: 'Submit',
      APPLIANCE_DETAILS_STEPPED_FORM_WARRANTY_ERROR_REQUIRED:
        'Please provide your appliance warranty',
      APPLIANCE_DETAILS_STEPPED_FORM_FIRST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      APPLIANCE_DETAILS_STEPPED_FORM_FIRST_NAME_ERROR_REQUIRED:
        'Please enter a first name',
      APPLIANCE_DETAILS_STEPPED_FORM_FIRST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      APPLIANCE_DETAILS_STEPPED_FORM_LAST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      APPLIANCE_DETAILS_STEPPED_FORM_LAST_NAME_ERROR_REQUIRED:
        'Please enter a last name',
      APPLIANCE_DETAILS_STEPPED_FORM_LAST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_REQUIRED:
        'Please enter a registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_ERROR_MIN_LENGTH:
        'Please select a value of minimum 9 characters',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_ERROR_MAX_LENGTH:
        'Please select a value of maximum 10 characters',
      APPLIANCE_DETAILS_STEPPED_FORM_WHERE_TO_FIND_REGISTRATION_CODE:
        'Where to find your registration code:',
      APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_A_REGISTRATION_CODE:
        'I have a registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_NO_REGISTRATION_CODE:
        "I don't have a registration code",
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_ERROR_REQUIRED:
        'Please provide a valid registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_I_DONT_HAVE_MODEL_OR_SERIAL_NUMBER:
        'I don’t have my model or serial number',
      APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE_PREFIX:
        'Come back when you have your product information”, or call us at ',
      APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE:
        ' {{telephoneNumber}}',
      APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE_SUFFIX:
        'for support.',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_SERIAL_NUMBER_FIELD_LABEL:
        'Please provide your model and serial number',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIALIZATION_RESPONSE_SUCCESS: 'Success!',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_FIELD_LABEL:
        'Please enter your registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_FIELDSET_LEGEND_NOTE_SERIALIZATION_RESPONSE_SUCCESS:
        'We found these details for registration code: {{ registrationCode }}. If they are incorrect, please update them below.',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_SERIAL_FIELDSET_INVALID_SERIALISATION_CODE_DESCRIPTION:
        'We couldn’t find your registration code. Go back and try again or enter your model and serial number below. This will help us provide you with a better warranty service if you ever need a repair.',
      PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_REQUIRED:
        'Please enter a first name',
      PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_REQUIRED:
        'Please enter a last name',
      PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_REQUIRED:
        'Please enter an email address',
      PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_EMAIL:
        'Please enter a valid email address',
      PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      PERSONAL_DETAILS_FORM_TELEPHONE_NUMBER_ERROR_REQUIRED:
        'Please enter a telephone number',
      PERSONAL_DETAILS_FORM_TELEPHONE_NUMBER_ERROR_PATTERN:
        'Please enter a valid phone number',
      PERSONAL_DETAILS_FORM_PRIVACY_POLICY_ERROR_REQUIRED:
        'Please confirm you agree to the privacy notice',
      PERSONAL_DETAILS_FORM_ADDRESS_LABEL: 'Your address*',
    },
    [LocaleId.English_Ireland]: {
      APPLIANCE_DETAILS_CONTINUE_BUTTON: 'Skip and continue to checkout',
      APPLIANCE_DETAILS_STEPPED_FORM_APPLIANCE_CATEGORY_CODE_ERROR_REQUIRED:
        'Please select an appliance category',
      APPLIANCE_DETAILS_STEPPED_FORM_APPLIANCE_CODE_ERROR_REQUIRED:
        'Please select an appliance',
      APPLIANCE_DETAILS_STEPPED_FORM_APPLIANCE_CODE_BUILT_IN_ERROR_REQUIRED:
        'Please select a value',
      APPLIANCE_DETAILS_STEPPED_FORM_BRAND_CODE_ERROR_REQUIRED:
        'Please select a brand',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_NUMBER_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_NUMBER_ERROR_REQUIRED:
        'Please enter your model number',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_SERIAL_NUMBER_ARE_INCORRECT:
        'No, this is incorrect',

      APPLIANCE_DETAILS_STEPPED_FORM_PHOTO_REG_PANEL_TITLE:
        "We've captured your appliance information",
      APPLIANCE_DETAILS_STEPPED_FORM_PHOTO_REG_PANEL_SUBTITLE:
        'Continue with your registration below',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_DATE_ERROR_AFTER_DATE:
        'Please select a date that is in the last 8 years',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_DATE_ERROR_BEFORE_DATE:
        'Please select a date that is in the past',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_DATE_ERROR_REQUIRED:
        'Please select a purchase date',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_ERROR_REQUIRED:
        'Please enter a purchase price',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_ERROR_MIN_LENGTH:
        'Please enter a value greater than 1',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_ERROR_MAX_LENGTH:
        "You've exceeded the maximum price",
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_SUMMARY_PANEL_TITLE:
        'Check your appliance information is correct.',
      APPLIANCE_DETAILS_STEPPED_FORM_REQUIRED_FIELD: '* Required field',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIAL_NUMBER_ERROR_MAX_LENGTH:
        'Enter a minimum of 9 and a maximum of 20 characters.',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIAL_NUMBER_ERROR_MIN_LENGTH:
        'Enter a minimum of 9 and a maximum of 20 characters.',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIAL_NUMBER_ERROR_REQUIRED:
        'Please enter your serial number',
      APPLIANCE_DETAILS_STEPPED_FORM_SUBMIT_BUTTON: 'Continue',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_SUBMIT: 'Submit',
      APPLIANCE_DETAILS_STEPPED_FORM_WARRANTY_ERROR_REQUIRED:
        'Please provide your appliance warranty',
      APPLIANCE_DETAILS_STEPPED_FORM_FIRST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      APPLIANCE_DETAILS_STEPPED_FORM_FIRST_NAME_ERROR_REQUIRED:
        'Please enter a first name',
      APPLIANCE_DETAILS_STEPPED_FORM_FIRST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      APPLIANCE_DETAILS_STEPPED_FORM_LAST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      APPLIANCE_DETAILS_STEPPED_FORM_LAST_NAME_ERROR_REQUIRED:
        'Please enter a last name',
      APPLIANCE_DETAILS_STEPPED_FORM_LAST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_REQUIRED:
        'Please enter a registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_ERROR_MIN_LENGTH:
        'Please select a value of minimum 9 characters',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_ERROR_MAX_LENGTH:
        'Please select a value of maximum 10 characters',
      APPLIANCE_DETAILS_STEPPED_FORM_WHERE_TO_FIND_REGISTRATION_CODE:
        'Where to find your registration code:',
      APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_A_REGISTRATION_CODE:
        'I have a registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_NO_REGISTRATION_CODE:
        "I don't have a registration code",
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_ERROR_REQUIRED:
        'Please provide a valid registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_I_DONT_HAVE_MODEL_OR_SERIAL_NUMBER:
        'I don’t have my model or serial number',
      APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE_PREFIX:
        'Come back when you have your product information”, or call us at ',
      APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE:
        ' {{telephoneNumber}}',
      APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE_SUFFIX:
        'for support.',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_SERIAL_NUMBER_FIELD_LABEL:
        'Please provide your model and serial number',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_FIELD_LABEL:
        'Please enter your registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIALIZATION_RESPONSE_SUCCESS: 'Success!',
      APPLIANCE_DETAILS_STEPPED_FORM_FIELDSET_LEGEND_NOTE_SERIALIZATION_RESPONSE_SUCCESS:
        'We found these details for registration code: {{ registrationCode }}. If they are incorrect, please update them below.',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_SERIAL_FIELDSET_INVALID_SERIALISATION_CODE_DESCRIPTION:
        'We couldn’t find your registration code. Go back and try again or enter your model and serial number below. This will help us provide you with a better warranty service if you ever need a repair.',
      PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_REQUIRED:
        'Please enter a first name',
      PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_REQUIRED:
        'Please enter a last name',
      PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_REQUIRED:
        'Please enter an email address',
      PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_EMAIL:
        'Please enter a valid email address',
      PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      PERSONAL_DETAILS_FORM_TELEPHONE_NUMBER_ERROR_REQUIRED:
        'Please enter a telephone number',
      PERSONAL_DETAILS_FORM_TELEPHONE_NUMBER_ERROR_PATTERN:
        'Please enter a valid phone number',
      PERSONAL_DETAILS_FORM_PRIVACY_POLICY_ERROR_REQUIRED:
        'Please confirm you agree to the privacy notice',
      PERSONAL_DETAILS_FORM_ADDRESS_LABEL: 'Your address*',
    },
    [LocaleId.English_US]: {
      APPLIANCE_DETAILS_CONTINUE_BUTTON: 'Skip and continue to checkout',
      APPLIANCE_DETAILS_STEPPED_FORM_APPLIANCE_CATEGORY_CODE_ERROR_REQUIRED:
        'Please select an appliance category',
      APPLIANCE_DETAILS_STEPPED_FORM_APPLIANCE_CODE_ERROR_REQUIRED:
        'Please select an appliance',
      APPLIANCE_DETAILS_STEPPED_FORM_APPLIANCE_CODE_BUILT_IN_ERROR_REQUIRED:
        'Please select a value',
      APPLIANCE_DETAILS_STEPPED_FORM_BRAND_CODE_ERROR_REQUIRED:
        'Please select a brand',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_NUMBER_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_NUMBER_ERROR_REQUIRED:
        'Please enter your model number',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_SERIAL_NUMBER_ARE_INCORRECT:
        'No, this is incorrect',
      APPLIANCE_DETAILS_STEPPED_FORM_PHOTO_REG_PANEL_TITLE:
        "We've captured your appliance information",
      APPLIANCE_DETAILS_STEPPED_FORM_PHOTO_REG_PANEL_SUBTITLE:
        'Continue with your registration below',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_DATE_ERROR_AFTER_DATE:
        'Please select a date that is in the last 8 years',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_DATE_ERROR_BEFORE_DATE:
        'Please select a date that is in the past',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_DATE_ERROR_REQUIRED:
        'Please select a purchase date',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_ERROR_REQUIRED:
        'Please enter a purchase price',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_ERROR_MIN_LENGTH:
        'Please enter a value greater than 1',
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_ERROR_MAX_LENGTH:
        "You've exceeded the maximum price",
      APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_SUMMARY_PANEL_TITLE:
        'Check your appliance information is correct.',
      APPLIANCE_DETAILS_STEPPED_FORM_REQUIRED_FIELD: '* Required field',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIAL_NUMBER_ERROR_MAX_LENGTH:
        'Enter a minimum of 9 and a maximum of 20 characters.',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIAL_NUMBER_ERROR_MIN_LENGTH:
        'Enter a minimum of 9 and a maximum of 20 characters.',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIAL_NUMBER_ERROR_REQUIRED:
        'Please enter your serial number',
      APPLIANCE_DETAILS_STEPPED_FORM_SUBMIT_BUTTON: 'Continue',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_SUBMIT: 'Submit',
      APPLIANCE_DETAILS_STEPPED_FORM_WARRANTY_ERROR_REQUIRED:
        'Please provide your appliance warranty',
      APPLIANCE_DETAILS_STEPPED_FORM_FIRST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      APPLIANCE_DETAILS_STEPPED_FORM_FIRST_NAME_ERROR_REQUIRED:
        'Please enter a first name',
      APPLIANCE_DETAILS_STEPPED_FORM_FIRST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      APPLIANCE_DETAILS_STEPPED_FORM_LAST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      APPLIANCE_DETAILS_STEPPED_FORM_LAST_NAME_ERROR_REQUIRED:
        'Please enter a last name',
      APPLIANCE_DETAILS_STEPPED_FORM_LAST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_REQUIRED:
        'Please enter a registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_ERROR_MIN_LENGTH:
        'Please select a value of minimum 9 characters',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_ERROR_MAX_LENGTH:
        'Please select a value of maximum 10 characters',
      APPLIANCE_DETAILS_STEPPED_FORM_WHERE_TO_FIND_REGISTRATION_CODE:
        'Where to find your registration code:',
      APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_A_REGISTRATION_CODE:
        'I have a registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_NO_REGISTRATION_CODE:
        "I don't have a registration code",
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_ERROR_REQUIRED:
        'Please provide a valid registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_I_DONT_HAVE_MODEL_OR_SERIAL_NUMBER:
        'I don’t have my model or serial number',
      APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE_PREFIX:
        'Come back when you have your product information”, or call us at ',
      APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE:
        ' {{telephoneNumber}}',
      APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE_SUFFIX:
        'for support.',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_SERIAL_NUMBER_FIELD_LABEL:
        'Please provide your model and serial number',
      APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_FIELD_LABEL:
        'Please enter your registration code',
      APPLIANCE_DETAILS_STEPPED_FORM_SERIALIZATION_RESPONSE_SUCCESS: 'Success!',
      APPLIANCE_DETAILS_STEPPED_FORM_FIELDSET_LEGEND_NOTE_SERIALIZATION_RESPONSE_SUCCESS:
        'We found these details for registration code: {{ registrationCode }}. If they are incorrect, please update them below.',
      APPLIANCE_DETAILS_STEPPED_FORM_MODEL_SERIAL_FIELDSET_INVALID_SERIALISATION_CODE_DESCRIPTION:
        'We couldn’t find your registration code. Go back and try again or enter your model and serial number below. This will help us provide you with a better warranty service if you ever need a repair.',
      PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_REQUIRED:
        'Please enter a first name',
      PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_REQUIRED:
        'Please enter a last name',
      PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_REQUIRED:
        'Please enter an email address',
      PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_EMAIL:
        'Please enter a valid email address',
      PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      PERSONAL_DETAILS_FORM_TELEPHONE_NUMBER_ERROR_REQUIRED:
        'Please enter a telephone number',
      PERSONAL_DETAILS_FORM_TELEPHONE_NUMBER_ERROR_PATTERN:
        'Please enter a valid phone number',
      PERSONAL_DETAILS_FORM_PRIVACY_POLICY_ERROR_REQUIRED:
        'Please confirm you agree to the privacy notice',
      PERSONAL_DETAILS_FORM_ADDRESS_LABEL: 'Your address*',
    },
  };
